import { getSupabaseClient } from '../../lib/supabase';

export type TutorRealtimeStatus = 'connecting' | 'connected' | 'reconnecting' | 'disconnected';

export function subscribeSupabaseLearnerProgressWithStatus(
  studentId: string,
  onRefresh: () => void,
  onStatus: (status: TutorRealtimeStatus) => void,
) {
  const client = getSupabaseClient();
  if (!client) {
    onStatus('disconnected');
    return () => undefined;
  }

  let active = true;
  onStatus('connecting');

  const channel = client
    .channel(`tutor-progress-${studentId}-${Math.random().toString(36).slice(2)}`)
    .on(
      'postgres_changes',
      {
        event: '*',
        schema: 'public',
        table: 'student_skill_progress',
        filter: `student_id=eq.${studentId}`,
      },
      () => {
        if (active) onRefresh();
      },
    )
    .subscribe((status) => {
      if (!active) return;
      if (status === 'SUBSCRIBED') {
        onStatus('connected');
      } else if (status === 'CHANNEL_ERROR' || status === 'TIMED_OUT') {
        onStatus('reconnecting');
      } else if (status === 'CLOSED') {
        onStatus('disconnected');
      }
    });

  return () => {
    active = false;
    void client.removeChannel(channel);
  };
}
